import { useAppSelector } from "../redux"

export const useIsDesktop = () => {
  const isDesktop = useAppSelector((state) => state.store.isDesktop)
  return isDesktop
}